import axios from "axios";

import { useState, useEffect } from "react";
import { BACKEND } from "../config/configEnvs";
import { FaComment, FaEye, FaEyeSlash, FaNetworkWired, FaTimes } from "react-icons/fa";
import { Button, linkClasses } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import LoadingScreen from "../components/ui/temp-screens/LoadingScreen";
import NoDataScreen from "../components/ui/temp-screens/NoDataScreen";
import PaginationItem from "../components/ui/components/Pagination";
import DetailsButton from "../components/ui/components/DetailsButton";
import { formatDate, getFormattedMonthAndYear } from "../utils/rawData/dateValues";
import HandleUpdateSelect from "../utils/HandleUpdateSelect";
import HandleUpdateSelectSelf from "../utils/HandleUpdateSelectSelf";
import { toast } from "react-toastify";
import Tooltip from "../components/ui/ToolTip";
import CopyToClipBoard from "../utils/CopyToClipBoard";
import IdButton from "../components/ui/components/IdButton";
import EmptyButton from "../components/ui/components/EmptyButton";
import DrawerCotizacionCalendarioPagosDetails from "../components/calendarioPagos/DrawerCotizacionCalendarioPagosDetails";
import { FaCalendarDays, FaMoneyBillTrendUp } from "react-icons/fa6";
import { useSelector } from "react-redux";
import { months, years } from "../utils/rawData/dateValues";
import useEnhancedEffect from "@mui/material/utils/useEnhancedEffect";
import { PlanBackgroundColor } from "../utils/GetTextColor";
import ObtenerMultiplicador from "../utils/preciosPaises/obtenerMultiplicador";
import CalcularPrecioPais from "../utils/preciosPaises/calcularPrecioPais";

const RegistroComisiones = () => {

  // usuario
  const user = useSelector((state) => state.auth.user);
  const isAdmin = user.area.toUpperCase() === "ADMINISTRACION" && user.puesto.toUpperCase() !== "ASISTENTE"

  // Estado de carga
  const [loading, setLoading] = useState(false); 

  const [selectedSeller, setSelectedSeller] = useState(""); // Vendedor seleccionado
  const [sellers, setSellers] = useState([]); // Vendedores

  // Data
  const [payments, setPayments] = useState([]);
  const [services, setServices] = useState([]);
  // console.log(services)
  const [record, setRecord] = useState([]);

  // Regias y comisiones
  const [individualRules, setIndividualRules] = useState([]);
  const [rules, setRules] = useState([]);
  const [goals, setGoals] = useState([]);

  // Países
  const [paises, setPaises] = useState([]);
  
  // Filtro de fechas
  const [month, setMonth] = useState(new Date().getMonth() + 1); // Mes seleccioando
  const [year, setYear] = useState(new Date().getFullYear()); // Año seleccioando

  const updateDates = (newMonth, newYear) => { // Funcion para obtener el primer y último día del mes seleccinoado en funciona a los selectores.
    const startDate = new Date(newYear, newMonth - 1, 1); // Primer día del mes
    const endDate = new Date(newYear, newMonth, 0); // Último día del mes
    
    // Restamos 5 horas para ajustar a la zona horaria de Lima
    // startDate.setHours(startDate.getHours() - 5);
    // endDate.setHours(endDate.getHours() - 5);

    console.log("Fecha inicio: ", startDate)
    console.log("Fecha fin: ", endDate)

    setFilterForms({
      fechaInicio: startDate,
      fechaFin: endDate
    });
  };

  useEffect(() => { // Cada que cambia mes o año, se actualizan las fechas de inicio y fin en el filterForms
    updateDates(month, year);
  }, [month, year]);

  const [filterForms, setFilterForms] = useState({
    fechaInicio: new Date(year, month - 1, 1),
    fechaFin: new Date(year, month, 0)
  });
  
  
  // Sumamos 5 horas para ajustar a la zona horaria de Lima.
  //filterForms.fechaInicio.setHours(filterForms.fechaInicio.getHours() - 5);
  //filterForms.fechaFin.setHours(filterForms.fechaFin.getHours() - 5);
  
  const getSellers = async () => {
    try {
      const response = await axios.get(`${BACKEND}/api/trabajadores?where[area][equals]=Comercial&limit=0`);
      setSellers(response.data.docs);
    } catch (error) {
      console.log(error);
    }
  }
  
  const getIndividualGoals = async () => { // Metas individuales
    try {
      const response = await axios.get(`${BACKEND}/api/metaIndividualComercial?limit=0`)
      setIndividualRules(response.data.docs)
    } catch (e) {
      return false
    }
  }

  const getCommissions = async () => { // Reglas de comisiones
    try {
      const response = await axios.get(`${BACKEND}/api/reglasComisiones?limit=0`)
      setRules(response.data.docs)
    } catch (e) {
      return false
    }
  }

  const getServices = async () => { // Servicios
    try {
      const response = await axios.get(`${BACKEND}/api/servicios?limit=0`)
      setServices(response.data.docs)
    } catch (e) {
      return false
    }
  }

  const getRecord = async () => { // Main function

    const page = 1
    const limit = 0
  
    const baseUrl = `${BACKEND}/api/serviciosCotizaciones`;
    const queryParams = {
      page,
      limit,
      'where[cotizacion.estado][equals]': 'Exito',
      //'where[cotizacion.primeraCotizacion][equals]': true,
    };
  
    let andFilters = [];

    if (selectedSeller) {
      andFilters.push({
        [`cotizacion.cotizador`]: {
          equals: selectedSeller,
        }
      });
    }
  
    // Fecha: agrupar como and[]
    if (filterForms.fechaInicio) {
      andFilters.push({
        [`cotizacion.fechaVenta`]: {
          greater_than_equal: new Date(filterForms.fechaInicio).toISOString(),
        }
      });
    }
  
    if (filterForms.fechaFin) {
      andFilters.push({
        [`cotizacion.fechaVenta`]: {
          less_than_equal: new Date(filterForms.fechaFin).toISOString(),
        }
      });
    }
  
    // Si hay filtros AND, los agregamos al query
    if (andFilters.length > 0) {
      andFilters.forEach((filter, index) => {
        const key = `where[and][${index}][${Object.keys(filter)[0]}][${Object.keys(filter[Object.keys(filter)[0]])[0]}]`;
        const value = Object.values(Object.values(filter)[0])[0];
        queryParams[key] = value;
      });
    }
  
    // Convertimos todo a query string
    const queryString = new URLSearchParams(queryParams).toString();
  
    try {
      setLoading(true)

      const response = await axios.get(`${baseUrl}?${queryString}`);

      console.log("Servicios vendidos: ", response.data.totalDocs)
      setRecord(response.data.docs.sort((a, b) => new Date(a.cotizacion.fechaVenta) - new Date(b.cotizacion.fechaVenta)));

    } catch (e) {
      toast.error("Error al cargar los datos: " + e);
    } finally {
      setLoading(false)
    }
  };

  const getPaises = async () => {
    try {
      const response = await axios.get(`${BACKEND}/api/paises?limit=0`)
      setPaises(response.data.docs)
    } catch (e) {
      return false
    }
  }

  useEnhancedEffect(() => {
    getRecord();
  }, [filterForms, selectedSeller]);

  useEffect(() => { 
    getSellers();
    getIndividualGoals();
    getCommissions();
    getServices();
    getPaises();
    getCurrencyExchange();
    getRecord()
  }, []);

  // Drawer
  const [openDrawer, setOpenDrawer] = useState(false);
  const [dataDrawer, setDataDrawer] = useState(null);

  const [currencyExchanges, setCurrencyExchanges] = useState({})

  const getCurrencyExchange = async () => {
    try {
      const response = await axios.get(`${BACKEND}/api/tiposCambio?limit=0`)
      const currencyExchanges = response.data.docs.reduce((acc, item) => {
        acc[item.moneda] = item.tipoCambio
        return acc
      }, {})
      setCurrencyExchanges(currencyExchanges)
    } catch (error) {
      return false
    }
  }

  const handleOpenDrawer = (data) => {
    setDataDrawer(data)
    setOpenDrawer(true)
  } 

  return (
    <div className="flex flex-col h-screen w-full">

      <DrawerCotizacionCalendarioPagosDetails
        onClose={() => setOpenDrawer(false)}
        open={openDrawer}
        dataDrawer={dataDrawer}
        refetch={getRecord}
        isAdmin={isAdmin}
        paises={paises}
        currencyExchanges={currencyExchanges}
      />

      {/* NavBar */}
      <div className="flex flex-row px-4 py-2 bg-gray-100">
        <div className="flex flex-row w-full items-center gap-4 justify-between overflow-x-auto overflow-y-hidden px-4 [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]">
          
          <div className="flex items-center gap-4 py-4">
            <FaMoneyBillTrendUp className="text-zinc-700 text-2xl" />
            <h2 className="text-2xl font-bold text-zinc-700">Registro de comisiones</h2>
          </div>

          <div className="flex flex-row gap-4 items-center justify-center">
           
            <div className="flex flex-row text-xs text-gray-700 items-center justify-center gap-4">
              <span>Vendedor:</span>
              <select
                value={selectedSeller}
                onChange={(e) => setSelectedSeller(e.target.value)}
                className="text-gray-700 hover:cursor-pointer text-xs bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent py-[6px] pr-10"
              >
                <option value="">Todos</option>
                {sellers.map((s) => (
                  <option key={s.id} value={s.id}>{s.name}</option>
                ))}
              </select>
            </div>

          </div>

        </div>
      </div>

      {/* Filtros */}
      <div className="flex bg-gray-100 mt-0.5 mb-0.5 justify-between w-full gap-10">
        <div className="flex flex-row gap-4 items-center justify-center w-full px-4">

          <div className="flex flex-row text-xs text-gray-700 items-center justify-center gap-4">
            <span>Mes:</span>
            <select
              value={month}
              onChange={(e) => setMonth(parseInt(e.target.value))}
              className="text-gray-700 hover:cursor-pointer text-xs bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent py-[6px] pr-10"
            >
              {months.map((month, index) => (
                <option key={index} value={index + 1}>
                  {month.label}
                </option>
              ))}
            </select>
          </div>

          <div className="flex flex-row text-xs text-gray-700 items-center justify-center gap-4">
            <span>Año:</span>
            <select
              value={year}
              onChange={(e) => setYear(parseInt(e.target.value))}
              className="text-gray-700 hover:cursor-pointer text-xs bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent py-[6px] pr-10"
            >
              {years.map((year, index) => (
                <option key={index} value={year.value}>
                  {year.label}
                </option>
              ))}
            </select>
          </div>

        </div>
      </div>

      {/* Body */}
      <div className="flex-grow overflow-y-auto">
        {loading ? (
            <LoadingScreen />
          ) : (
            record.length == 0 ? (
              <NoDataScreen />
            ) : (
              <table className="w-full">
                <thead className="bg-white sticky top-0">
                  <tr className="text-gray-700 text-center text-[10px] font-bold">
                    <th className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                      Cotización
                    </th>
                    <th className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                      Fecha de venta
                    </th>
                    <th className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                      Encargado
                    </th>
                    <th className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                      Marca
                    </th>
                    <th className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                      Tipo comision
                    </th>
                    <th className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                      Mes
                    </th>
                    <th className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                      Servicio
                    </th>
                    <th className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                      Plan
                    </th>
                    <th className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                      Meses
                    </th>
                    <th className="px-2 py-3 truncate text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                      Valor venta
                    </th>
                    <th className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                      Com. totales
                    </th>
                    <th className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                      Adelanto
                    </th>
                    <th className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                      Debe
                    </th>
                    <th className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                      %
                    </th>
                    <th className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                      Medio
                    </th>
                    <th className="px-2 py-3 truncate text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                      Vendedor
                    </th>
                  </tr>
                </thead>
                
                <tbody>
                  {record.map((r, i) => {

                    const servicio = services.find((s) => s.id === r.servicio.id)
                    const precioEncontrado = servicio?.preciosUnitarios?.find((ev2) => ev2.plan.id === r.planServicio.id)
                    const valorVenta = (() => {
                      // Obtener precio unitario base con multiplicador por país
                      const precioUnitario = r.customPriceActive
                        ? r.customPrice
                        : r.servicio && r.planServicio &&
                          CalcularPrecioPais({
                            precio: precioEncontrado?.precio || 0,
                            multiplicador: ObtenerMultiplicador({
                              pais: r.cotizacion?.cliente?.pais || r.cotizacion?.lead?.country,
                              paises: paises
                            })
                          });
                      
                      //console.log(`Precio unitario de ${r.cotizacion?.cliente?.nombreComercial}: ` + precioUnitario)

                      // Calcular descuento unitario
                      let descuentoUnitario = 0;
                      if (r.tipoDescuento === "Porcentaje") {
                        descuentoUnitario = precioUnitario * (r.montoDescuento / 100);
                      } else if (r.tipoDescuento === "Fijo") {
                        descuentoUnitario = r.montoDescuento;
                      }

                      console.log("Descuento unitario: " + descuentoUnitario)

                      // Retornar precio unitario con descuento
                      return (precioUnitario - descuentoUnitario).toLocaleString("es-PE", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
                    })()

                    return (
                      <tr key={r.id} className="text-xs py-3 w-full hover:bg-gray-100 transition-all duration-100">
                        
                        <td className="px-4 py-2 whitespace-nowrap text-center border border-gray-300 z-10">
                          <div className="flex items-center justify-center">
                            <DetailsButton content="Ver cotización" action={() => handleOpenDrawer(r.cotizacion)} />
                          </div>
                        </td>

                        <td scope="row" className="px-4 py-3  text-center whitespace-nowrap border border-gray-300">
                          <span className="flex items-center justify-center">
                            {formatDate(r.cotizacion.fechaVenta.split("T")[0])}
                          </span>
                        </td>

                        <td scope="row" className="px-4 py-3 text-center whitespace-nowrap border border-gray-300">
                          <span className="flex items-center justify-center">
                            {r.cotizacion?.cliente?.encargadoProyecto}
                          </span>
                        </td>
 
                        <td scope="row" className="px-4 py-3 text-center whitespace-nowrap border border-gray-300">
                          <span className="flex items-center justify-center">
                            {r.cotizacion?.cliente?.nombreComercial}
                          </span>
                        </td>

                        <td scope="row" className="px-4 py-3 text-center whitespace-nowrap border border-gray-300">
                          <span className="flex items-center justify-center">
                            {"Tipo comisión"}
                          </span>
                        </td>

                        <td scope="row" className="px-4 py-3 text-center whitespace-nowrap border border-gray-300">
                          <span className="flex items-center justify-center">
                            {getFormattedMonthAndYear(r.cotizacion.fechaVenta).month}
                          </span>
                        </td>

                        <td scope="row" className="px-4 py-3 text-center whitespace-nowrap border border-gray-300">
                          <span className="flex items-center justify-center">
                            {r.servicio.name}
                          </span>
                        </td>

                        <td scope="row" className="px-4 py-3 text-center whitespace-nowrap border border-gray-300">
                          <span className="flex items-center justify-center">
                            <span className={`px-2 rounded-md ${PlanBackgroundColor[r.planServicio?.name] || "text-black"}`}>
                              {r.planServicio?.name}
                            </span>
                          </span>
                        </td>

                       <td scope="row" className="px-4 py-3 text-center whitespace-nowrap border border-gray-300">
                          <span className="flex items-center justify-center">
                            {r.numeroItems}
                          </span>
                        </td>

                        <td scope="row" className="px-4 py-3 text-center whitespace-nowrap border border-gray-300">
                          <span className="flex items-center justify-center">
                            PEN {valorVenta}
                          </span>
                        </td>

                        <td scope="row" className="px-4 py-3 text-center whitespace-nowrap border border-gray-300">
                          <span className="flex items-center justify-center">
                            {"-"}
                          </span>
                        </td>

                        <td scope="row" className="px-4 py-3 text-center whitespace-nowrap border border-gray-300">
                          <span className="flex items-center justify-center">
                            {"-"}
                          </span>
                        </td>

                        <td scope="row" className="px-4 py-3 text-center whitespace-nowrap border border-gray-300">
                          <span className="flex items-center justify-center">
                            {"-"}
                          </span>
                        </td>

                        <td scope="row" className="px-4 py-3 text-center whitespace-nowrap border border-gray-300">
                          <span className="flex items-center justify-center">
                            {"-"}
                          </span>
                        </td>

                        <td scope="row" className={`px-4 py-3 text-center whitespace-nowrap border border-gray-300`}>
                          <span className={`flex items-center justify-center ${r.cotizacion?.lead?.leadOrigin ? "text-black" : "text-gray-200"}`}>
                            {r.cotizacion?.lead?.leadOrigin || "No definido"}
                          </span>
                        </td> 

                        <td scope="row" className={`px-4 py-3 text-center whitespace-nowrap border border-gray-300`}>
                          <span className="flex items-center font-bold justify-center">
                            {r.cotizacion?.cotizador?.name}
                          </span>
                        </td> 
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            )
          )
        }
      </div>

    </div>
  )
}

export default RegistroComisiones;